import { cn } from '@playbooks/ui/lib/utils';

const Empty = ({ className, ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn('flex min-w-0 flex-1 flex-col items-center justify-center gap-6 p-6 text-center', className);

	// Render
	return <div className={rootClassName} {...props} />;
};

const EmptyHeader = ({ className, ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn('flex max-w-sm flex-col items-center gap-2', className);

	// Render
	return <div className={rootClassName} {...props} />;
};

const EmptyMedia = ({ className, ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn(
		'mb-2 flex size-10 items-center justify-center rounded-media border border-border-strong bg-surface-control text-foreground-body',
		className,
	);

	// Render
	return <div className={rootClassName} {...props} />;
};

const EmptyContent = ({ className, ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn('flex max-w-sm flex-col items-center gap-1', className);

	// Render
	return <div className={rootClassName} {...props} />;
};

const EmptyTitle = ({ className, ...props }: React.ComponentProps<'h3'>) => {
	// Theme
	const rootClassName = cn('type-heading', className);

	// Render
	return <h3 className={rootClassName} {...props} />;
};

const EmptyDescription = ({ className, ...props }: React.ComponentProps<'p'>) => {
	// Theme
	const rootClassName = cn('text-sm text-foreground-body', className);

	// Render
	return <p className={rootClassName} {...props} />;
};

const EmptyActions = ({ className, ...props }: React.ComponentProps<'div'>) => {
	// Theme
	const rootClassName = cn('flex items-center justify-center gap-2', className);

	// Render
	return <div className={rootClassName} {...props} />;
};

export { Empty, EmptyActions, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle };
